module.exports = __webpack_public_path__ + "img/p5.1e555e6c.jpg";